import React, { useState } from "react";
import { PhoneNumberInputProps } from "./phone-number-input.props";
import { IPhoneNumber } from "src/types/models/apiModels";
import InputBox from "../v2/inputBox/inputBox";

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
	value,
	disabled,
	onChange,
}) => {
	const [phoneNumber, setPhoneNumber] = useState<IPhoneNumber>(value);

	const handleCountryCodeChange = (countryCode: string) => {
		const updatedPhoneNumber = {
			...phoneNumber,
			countryCode: countryCode,
		};
		setPhoneNumber(updatedPhoneNumber);
		if (onChange) {
			onChange(updatedPhoneNumber);
		}
	};

	const handleNumberChange = (number: string) => {
		const updatedPhoneNumber = { ...phoneNumber, number: number };
		setPhoneNumber(updatedPhoneNumber);
		if (onChange) {
			onChange(updatedPhoneNumber);
		}
	};

	return (
		<div className="flex items-center justify-center gap-4 w-full">
			<InputBox
				label={"Mobile No."}
				type={"text"}
				onChange={function (value: string): void {
					handleNumberChange(value);
				}}
				value={`+${phoneNumber.countryCode}${phoneNumber.number}`}
				disabled={disabled}
			></InputBox>
		</div>
	);
};

export default PhoneNumberInput;
